import { del, get, post, put } from '../client';

export const rolesApi = {
  list: (params) => get('/roles', { params }),
  getById: (id) => get(`/roles/${id}`),
  create: (body) => post('/roles', body),
  update: (id, body) => put(`/roles/${id}`, body),
  updatePermissions: (id, permissions) =>
    put(`/roles/${id}/permissions`, { permissions }),
  remove: (id) => del(`/roles/${id}`),
};
